
import React from 'react';

const SpeechGoalList = () => <div>TBD</div>;

export default SpeechGoalList;
